<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M19.55 25.8q2.47 0 4.2-1.76a5.8 5.8 0 0 0 1.75-4.22q0-2.47-1.75-4.2a5.8 5.8 0 0 0-4.22-1.75q-2.47 0-4.21 1.75a5.8 5.8 0 0 0-1.74 4.22q0 2.47 1.75 4.21a5.8 5.8 0 0 0 4.22 1.75m-.02-1.42a4.4 4.4 0 0 1-3.22-1.33 4.4 4.4 0 0 1-1.32-3.23q0-1.9 1.33-3.21a4.4 4.4 0 0 1 3.23-1.32q1.9 0 3.22 1.33a4.4 4.4 0 0 1 1.32 3.22q0 1.9-1.33 3.22a4.4 4.4 0 0 1-3.23 1.32m.01 6.29q-5.4 0-9.83-2.96A18.6 18.6 0 0 1 3 19.83a18.6 18.6 0 0 1 6.7-7.87A17.4 17.4 0 0 1 19.53 9q5.4 0 9.84 2.96 4.45 2.96 6.7 7.87a18.6 18.6 0 0 1-6.7 7.88 17.4 17.4 0 0 1-9.83 2.96m0-1.41q4.82 0 8.85-2.55t6.15-6.88a16.7 16.7 0 0 0-15-9.42q-4.83 0-8.85 2.55-4.03 2.56-6.16 6.87a16.7 16.7 0 0 0 15 9.43"
      />
    </svg>
  </span>
</template>
